export const ru = {
    'age-restriction-group-title': 'Возрастное ограничение',
    'age-restriction-group-tooltip':
        'Согласно требованиям законодательства реклама определенных товаров и услуг (например, информационной продукции и детского питания) должна содержать возрастную категорию (0+, 6+, 12+, 16+, 18+). {link}.',
    'age-restriction-title': 'Возраст',
    'background-color-title': 'Цвет заливки',
    'border-color-title': 'Цвет рамки',
    'button-background-color-tooltip':
        'Текст должен быть легко различим на фоне заливки и загруженного изображения. Цвета должны существенно различаться. {link}.',
    'button-group-title': 'Кнопка',
    'button-group-tooltip':
        'Кнопка должна соответствовать переходу на сайт или запуску приложения. Например, «подробнее», «заказать», «купить». {link}.',
    'color-group-title': 'Цвета',
    'color-title': 'Цвет текста',
    'common-border-tooltip': 'Цвет рамки должен отличаться от цвета фона (заливки, загруженного изображения). {link}.',
    'content-title': 'Текст',
    'description-group-title': 'Дополнительный текст',
    'disclaimer-group-title': 'Предупреждение',
    'disclaimer-group-tooltip':
        'Согласно требованиям законодательства реклама определенных товаров и услуг (например, лекарств, финансовых услуг, долевого строительства) должна содержать предупреждения или дополнительную информацию. {link}.',
    'disclaimer-title': 'Страна',
    'domain-group-title': 'Домен',
    'fade-color-title': 'Цвет',
    'fade-group-title': 'Тон',
    'fade-group-tooltip':
        'Тон — полупрозрачный однотонный слой поверх загруженного изображения. Позволяет сделать однородным разноцветный фон, чтобы не отвлекать внимание от основного текста и других элементов.',
    'headline-group-title': 'Основной текст',
    'icon-color-title': 'Цвет иконки',
    'image-group-title': 'Изображение',
    'image-group-tooltip': 'Можно загрузить изображение в формате PNG, JPEG или неанимированный GIF размером до 10 МБ',
    'image-title': 'Файл',
    'legal-group-title': 'Юридическая информация',
    'legal-group-tooltip':
        'Согласно требованиям законодательства реклама определенных товаров и услуг (например, лекарств, финансовых услуг, долевого строительства) должна содержать предупреждения или дополнительную информацию. {link}.',
    'link-text': 'Подробнее',
    'logo-group-title': 'Логотип',
    'logo-title': 'Файл',
    'special-group-title': 'Специальное предложение'
};
